import {POPUPMENU_VISIBILITY} from '../../constants';
import { withType } from '../../../utils/actionOperations';
export function popupMenuVisible(params) {
    return dispatch => {
        dispatch(withType(POPUPMENU_VISIBILITY, params));
    };
}
